import { Count } from "@/app/collections/view/count"
import type { MinimalDrop } from "@anaconda/core/drop/types"
import { Trans } from "@lingui/react/macro"

export function ProgressBar({
  drop,
  mintedCount,
  withHeader = false,
  userMintedCount,
}: {
  drop: MinimalDrop
  mintedCount: number
  withHeader?: boolean
  userMintedCount?: number
}) {
  const { totalSupply } = drop

  if (!totalSupply) return null

  return (
    <div className="flex flex-col gap-1">
      {withHeader && (
        <div className="flex flex-wrap items-center justify-between gap-1 text-foreground/100">
          <span>
            <Trans>Total minted</Trans>{" "}
            {userMintedCount !== undefined && userMintedCount > 0 && (
              <span className="text-foreground/60">
                (
                <Trans>
                  <Count value={userMintedCount} /> by you
                </Trans>
                )
              </span>
            )}
          </span>
          <span>
            {mintedCount ? Math.round((mintedCount / totalSupply) * 100) : 0}%{" "}
            <span className="text-foreground/60">
              ({mintedCount} / {totalSupply})
            </span>
          </span>
        </div>
      )}
      <div className="py-2">
        <div className="relative h-1 w-full rounded-full bg-foreground/10">
          <div
            className="absolute inset-0 h-full rounded-full bg-brand shadow-[0_0_8px_0_hsl(var(--brand))] transition-all duration-300"
            style={{
              width: `${(mintedCount / totalSupply) * 100}%`,
            }}
          />
        </div>
      </div>
    </div>
  )
}
